import React, { useEffect } from 'react'
import { LayoutBand, Skeleton, Card, colors, FlowGrid, usePageWidth, Bleed, Row } from '@fs/zion-ui'
import { useEvent } from '@fs/zion-frontend-friends'
import { usePageView } from '@fs/zion-analytics'
import { Title } from '@fs/zion-head'
import { useTranslation } from 'react-i18next'
import { sortAndFilterGroups, useGroupsList } from '../services/getGroupsList'
import GroupLimitsProvider from '../providers/GroupLimitsProvider'
import GroupList from '../components/group-lists/GroupList'
import JoinGroupOverlay from '../components/join-group-overlay/JoinGroupOverlay'

export default function FamilyGroupsListPage() {
  usePageView({ page_detail: 'View List: FG' }) // page_detail updates link_page for all analytics past this point
  const [{ data, loading }, refetch] = useGroupsList()
  const atPageWidth = usePageWidth()
  const isMobile = atPageWidth({ lg: false, default: true })
  const [t] = useTranslation()

  const refetchGroupList = useEvent(() => refetch())

  // When routing client-side back to this list, we need to call refetch to update the list
  useEffect(() => {
    refetchGroupList()
  }, [refetchGroupList])

  const sortedGroups = sortAndFilterGroups({
    groups: data?.memberSummaries || [],
    isFamily: true,
  })

  if (typeof loading === 'undefined' || loading)
    return (
      <>
        <LayoutBand marginY="xs">
          <Skeleton.H2 />
          <Skeleton.Paragraph lineCount={2} />
          {/* eslint-disable-next-line test-selectors/button -- loading skeleton */}
          <Skeleton.Button minWidth={160} />
        </LayoutBand>
        <LayoutBand color={colors.gray03} growY marginY="xs">
          <FlowGrid gutters="xs" columnCount={isMobile ? 1 : 2} orientation="vertical">
            {[...new Array(4)].map((d, i) => {
              return (
                // eslint-disable-next-line react/no-array-index-key -- loading skeleton
                <Card key={i} margins="xs">
                  <Bleed top start bottom>
                    <Row>
                      <Skeleton.Image width={121} height={91} />
                      <div growX>
                        <Skeleton.H4 />
                        <Skeleton.Chip />
                      </div>
                    </Row>
                  </Bleed>
                </Card>
              )
            })}
          </FlowGrid>
        </LayoutBand>
      </>
    )
  return (
    <>
      <Title>{t('group-management.family-groups.heading')}</Title>
      <GroupLimitsProvider>
        <GroupList
          refetchGroupList={refetchGroupList}
          totalGroupCount={data?.memberSummaries?.length}
          groups={sortedGroups}
        />
        {/* Overlay pops up if the URL has a `groupId` and `inviteId` query params */}
        <JoinGroupOverlay onJoinGroup={refetchGroupList} />
      </GroupLimitsProvider>
    </>
  )
}
